import XRegExp from 'xregexp';

export const nameRegExp = XRegExp("^[-.–'\\p{L}\\p{N}]+(?:\\s+[-.–'\\p{L}\\p{N}]+)*$");
